import script from "./industriesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./industriesList.vue?vue&type=script&lang=ts&setup=true"

import "./industriesList.vue?vue&type=style&index=0&id=5fdec93e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fdec93e"]])

export default __exports__